import React, { useState } from 'react';
import { Sidebar, Footer, sharedStyles } from './shared';
import ReportFormatter from './components/ReportFormatter';
import DisputeStrategy from './components/DisputeStrategy';
import DisputeLetters  from './components/DisputeLetters';

export default function App() {
  const [currentStep, setCurrentStep]       = useState(0);
  const [formattedReport, setFormattedReport] = useState(null);
  const [strategyData, setStrategyData]     = useState(null);
  const [selectedActions, setSelectedActions] = useState([]);

  // Which steps are unlocked
  const steps = {
    0: true,
    1: !!formattedReport,
    2: !!strategyData,
  };

  const handleFormatterComplete = (report) => {
    setFormattedReport(report);
    setCurrentStep(1);
  };

  const handleStrategyComplete = ({ strategy, selectedActions }) => {
    setStrategyData(strategy);
    setSelectedActions(selectedActions);
    setCurrentStep(2);
  };

  return (
    <div style={sharedStyles.root}>
      {/* Step Progress Bar */}
      <div style={{ background:'#0d0d0d', borderBottom:'1px solid #1a1a1a', padding:'8px 24px', display:'flex', alignItems:'center', gap:0 }}>
        {[
          { num:1, label:'Format Report',    step:0 },
          { num:2, label:'Build Strategy',   step:1 },
          { num:3, label:'Generate Letters', step:2 },
        ].map((item, i) => {
          const done   = currentStep > item.step;
          const active = currentStep === item.step;
          const locked = !steps[item.step];
          return (
            <React.Fragment key={item.step}>
              <div style={{ display:'flex', alignItems:'center', gap:8, opacity: locked?0.4:1 }}>
                <div style={{
                  width:26, height:26, borderRadius:'50%',
                  background: done?'#4caf7d':active?'#C9A84C':'#1a1a1a',
                  border:`2px solid ${done?'#4caf7d':active?'#C9A84C':'#2a2a2a'}`,
                  display:'flex', alignItems:'center', justifyContent:'center',
                  fontSize:'11px', fontWeight:700,
                  color: (done||active)?'#000':'#444',
                }}>
                  {done ? '✓' : item.num}
                </div>
                <span style={{ fontSize:'12px', fontWeight: active?600:400, color: done?'#4caf7d':active?'#C9A84C':'#666' }}>
                  {item.label}
                </span>
              </div>
              {i < 2 && (
                <div style={{ flex:1, height:2, background: currentStep>item.step?'#4caf7d':'#1a1a1a', margin:'0 12px', maxWidth:80 }} />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div style={sharedStyles.layout}>
        <Sidebar steps={steps} currentStep={currentStep} onStepClick={setCurrentStep} />

        <div style={{ flex:1, overflowY:'auto' }}>
          {currentStep === 0 && (
            <ReportFormatter onComplete={handleFormatterComplete} />
          )}
          {currentStep === 1 && formattedReport && (
            <DisputeStrategy
              report={formattedReport}
              onComplete={handleStrategyComplete}
            />
          )}
          {currentStep === 2 && strategyData && (
            <DisputeLetters
              report={formattedReport}
              strategy={strategyData}
              selectedActions={selectedActions}
            />
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
